import { useState } from 'react'
import { useRequest, useView } from '@10000/react'
import { InputScreen, onboardBackground, useBackground, useShell, useStack } from '../../layout'
import { Body, Box, Card, Icon, TeamLevelDescriptions } from '../../widgets'
import { TeamRole } from './'
import { isPartner, levels } from '../../../lookups'
import { backgroundColors } from '../../../utilities.js'

export const TeamLevel = ({ active, id, organisationId }) => {
  const request = useRequest('tenant')
  const { teams, user: { admin }, subscription } = useView('tenant')
  const { push } = useStack()

  useShell({
    active,
    mode: 'progress narrow',
    ...(admin ? isPartner(subscription) ? { step: 7, max: 8 } : { step: 5, max: 6 } : { step: 3, max: 4 })
  })
  useBackground().set(mobile => ({ active, fade: !admin, ...onboardBackground(admin, mobile) }))

  const [selectedLevel, setSelectedLevel] = useState(teams.find(x => x.id === id)?.level)

  const updateTeamLevel = () => {
    if(selectedLevel !== undefined) {
      return request('teamUpdated', { id, level: selectedLevel }).then(() => push(TeamRole, { props: { id, organisationId } }))
    }
  }

  return <InputScreen
    fade
    fadeColour={!admin && 'blue'}
    onSubmit={updateTeamLevel}
    footerButton="Next"
    title="Team level"
    description="Select your team&apos;s seniority level"
  >
    <TeamLevelDescriptions mobile />
    <Box className="scrolling-list">
      <Box wrap gap={8}>
        {levels.map((level, index) => <Card
          onClick={() => setSelectedLevel(index)}
          className={backgroundColors[index % backgroundColors.length]}
          key={index}
          cursor="pointer"
          radius={24}
          shadow={false}
          border={false}
          justifyContent="start"
          p="16px"
          width="auto"
          gap={10}
          height={52}
          grow
        >
          <Box
            background={backgroundColors[index] === "white" ? 'lightgrey' : 'white'}
            radius="50%"
            size={24}
            justifyContent="center"
            alignItems="center"
          >
            {selectedLevel === index && <Icon icon="Tick" size={20} fill="black"/>}
          </Box>
          <Body bold alt>{level.name}</Body>
        </Card>)}
      </Box>
    </Box>
    <TeamLevelDescriptions desktop />
  </InputScreen>
}